const MARKETING_HOSTNAMES = ["franklyadvisors.com", "www.franklyadvisors.com"];

export function isMarketingDomain(): boolean {
  return MARKETING_HOSTNAMES.includes(window.location.hostname);
}

export function getAppUrl(path: string = "/"): string {
  return `https://app.franklyadvisors.com${path}`;
}
